import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService } from '@shared/services/helper.service';
import { APPLICATION_ID, APPLICATION_ID_KEY } from '@module/submission-management/const/submission-management.const';
import { SubmissionManagementService } from '@module/submission-management/services/submission-management.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StoreService } from '@core/store/store.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-step-title',
  templateUrl: './step-title.component.html',
  styleUrls: ['./step-title.component.scss'],
  imports: [TranslateModule, CommonModule]
})
export class StepTitleComponent implements OnInit {

  @Input() data: any;
  @Input() type: string;
  @Input() parentComponent;
  instrumentIdText: string;
  hasPermission: boolean;
  legalName:string;
  instrumentIDlabel: string;

  constructor(
    private router: Router,
    private helperService: HelperService,
    private translateService: TranslateService,
    private submissionManagementService: SubmissionManagementService,
    private store: StoreService
  ) { }

  ngOnInit() {
    this.legalName = this.submissionManagementService.registrationReportsDetail.legalName || this.data.legalName;
    this.hasPermission = this.store.user.hasPermissionForAccount('VIEW_REGISTRATION_REPORT', this.data.accountId);
    this.setInstrumentIdtext();
    this.translateService.onLangChange.subscribe(() => {
      this.setInstrumentIdtext();
    });
  }

  goToRegistrationReport() {
    const subType = 'PS';
    sessionStorage.setItem(APPLICATION_ID, JSON.stringify(this.data.id));
    sessionStorage.setItem(APPLICATION_ID_KEY, JSON.stringify(this.data.id));
    this.submissionManagementService.storeCurrentData();
    this.store.storeCurrentUrl();
    if (this.data.registrationAccountId && !(this.data.status && ["IN_PROCESS", 'PROPOSED', 'NEED_MORE_INFORMATION'].includes(this.data.status))) {
      this.router.navigate(this.helperService.getTranslatedPath(`/cfr-registration/cfr/RRPS/${this.data.accountId}/${this.data.registrationAccountId}`));
    } else {
      this.router.navigate(this.helperService.getTranslatedPath(`/cfr-registration/cfr/RRPS/${this.data.accountId}`));
    }
  }

  private setInstrumentIdtext() {
     if(this.data.instrumentId){
      const label = `COMMON.submissionTypeList.${this.data.type}_ID`;
      this.instrumentIdText = `${this.translateService.instant(label)}: ${this.data.instrumentId}`;
    }
  }

}
